// extracted by mini-css-extract-plugin
module.exports = {"status":"complexity_status__BpmwF","beginner":"complexity_beginner__4J1c5","advanced":"complexity_advanced__DEWDK","master":"complexity_master__sQwqr"};